import React, { Component } from 'react';

export default class PageErrorBoundary extends Component {
    state = {
        error: null
    }

    static getDerivedStateFromError(err) {
        return { error: err };
    }

    render() {
        const { children } = this.props;
        const { error } = this.state;
        return error ? (
            <div className="page page-error">
                Something went wrong!
            </div>
        ) : children;
    }
}
